import { useState } from 'react';

import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';

import { GRADE } from '../../../constants';
import { Xmark } from '@gravity-ui/icons';
import styles from './styles.module.scss';

export const GradeSelect = ({ isMobile, formValues, index, register, setValue, errors, ratingNumbers }: any) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			{isMobile ? (
				<FormRow label={GRADE} className={styles.row} required>
					{(() => {
						return (
							<Select
								size="xl"
								hasClear
								open={isOpen}
								onOpenChange={setIsOpen}
								defaultValue={
									formValues.problems?.[index]?.importance
										? [String(formValues.problems?.[index]?.importance)]
										: []
								}
								{...register(`problems.${index}.importance`, { required: true })}
								onUpdate={(value) => {
									const selectedValue = value[0] || null;
									setValue(`problems.${index}.importance`, Number(selectedValue));
								}}
								validationState={errors?.problems?.[index]?.importance ? 'invalid' : undefined}
								errorPlacement="inside"
								errorMessage={
									errors?.problems?.[index]?.importance ? 'Обязательно для заполнения' : undefined
								}
								renderPopup={({ renderFilter, renderList }) => (
									<Sheet
										visible={isOpen}
										onClose={() => setIsOpen(false)}
										title="Выберите важность"
										className={styles.sheet}
									>
										<div className={styles.sheet__close}>
											<Button onClick={() => setIsOpen(false)} view="flat">
												<Icon data={Xmark} size={16} />
											</Button>
										</div>
										{renderList?.()}
									</Sheet>
								)}
							>
								{ratingNumbers.map((num: number) => (
									<Select.Option key={String(num)} value={String(num)}>
										{num}
									</Select.Option>
								))}
							</Select>
						);
					})()}
				</FormRow>
			) : (
				<FormRow label={GRADE} className={styles.row} required>
					<Select
						size="xl"
						hasClear
						defaultValue={
							formValues.problems?.[index]?.importance
								? [String(formValues.problems?.[index]?.importance)]
								: []
						}
						{...register(`problems.${index}.importance`, { required: true })}
						onUpdate={(value) => {
							const selectedValue = value[0] || null;

							setValue(`problems.${index}.importance`, Number(selectedValue));
						}}
						validationState={errors?.problems?.[index]?.importance ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={errors?.problems?.[index]?.importance ? 'Обязательно для заполнения' : undefined}
					>
						{ratingNumbers.map((num: number) => (
							<Select.Option key={String(num)} value={String(num)}>
								{num}
							</Select.Option>
						))}
					</Select>
				</FormRow>
			)}
		</>
	);
};
